import { Pipe, PipeTransform } from '@angular/core';
import { UtilCommon } from '../common/utils/UtilCommon';

@Pipe({
  name: 'currencyFormat',
})
export class CurrencyFormat implements PipeTransform {
  constructor() {

  }
  transform(value: any, format: string): string {
    try {
      if (value) {
        if (UtilCommon.checkIsString(format)) {
          value = parseInt(value, 0);
        }
        return UtilCommon.formatPrice_VND(value);
      }
      return value;
    } catch (error) {
      return '';
    }
  }
}
